const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'Ecozen Monitoring Dashboard',
      authRequired: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: 'Ecozen Login'
    }
  },
  {
    path: '/mqtt',
    name: 'mqtt-multiple-devices',
    component: () => import('../views/MqttMultipleDevices.vue'),
    meta: {
      title: 'Ecozen Mqtt Multi-device Dashboard',
      authRequired: true
    }
  },
  {
    path: '/fota',
    name: 'fota',
    component: () => import('../views/Fota.vue'),
    meta: {
      title: 'Ecozen Fota Dashboard',
      authRequired: true
    }
  },
  {
    path: '/schedule-mqtt',
    name: 'schedule-mqtt',
    component: () => import('../views/ScheduleMqtt.vue'),
    meta: {
      title: 'Ecozen Schedule Mqtt',
      authRequired: true
    }
  },
  {
    path: '/ecofrost/:topic/table',
    name: 'ecofrost-mqtt-data-table',
    component: () => import('../views/MqttDataTable.vue'),
    meta: {
      title: 'Mqtt Data Table',
      authRequired: true
    }
  },
  {
    path: '/ecotron/:topic/table',
    name: 'ecotron-mqtt-data-table',
    component: () => import('../views/MqttDataTable.vue'),
    meta: {
      title: 'Mqtt Data Table',
      authRequired: true
    }
  },
  {
    path: '/ecofrost/:topic/mqtt',
    name: 'ecofrost-mqtt',
    component: () => import('../views/MqttSingleDevice.vue'),
    meta: {
      title: 'Ecofrost Mqtt',
      authRequired: true
    }
  },
  {
    path: '/ecotron/:topic/mqtt',
    name: 'ecotron-mqtt',
    component: () => import('../views/MqttSingleDevice.vue'),
    meta: {
      title: 'Ecotron Mqtt',
      authRequired: true
    }
  },
  {
    path: '/ecofrost/:topic/profile',
    name: 'ecofrost-profile',
    component: () => import('../views/DeviceProfile.vue'),
    meta: {
      title: 'Profile',
      authRequired: true
    }
  },
  {
    path: '/ecotron/:topic/profile',
    name: 'ecotron-profile',
    component: () => import('../views/DeviceProfile.vue'),
    meta: {
      title: 'Profile',
      authRequired: true
    }
  },
  {
    path: '/ecofrost/:topic',
    name: 'ecofrost',
    component: () => import('../views/DeviceDetails.vue'),
    meta: {
      title: 'Ecofrost',
      authRequired: true
    }
  },
  {
    path: '/ecotron/:topic',
    name: 'ecotron',
    component: () => import('../views/DeviceDetails.vue'),
    meta: {
      title: 'Ecotron',
      authRequired: true
    }
  },
  //! Add this path at the last
  {
    path: '*',
    name: 'error',
    component: () => import('../views/Error.vue'),
    meta: {
      title: 'Error'
    }
  }
];

export default routes;
